import React from 'react';
import * as Yup from 'yup';
import { Modal, ModalActions, ModalContent } from '../../../../../Modal';
import { Box, Typography } from '@mui/material';
import { useUserQuery } from '@uplift/queries';
import { PatientUploadedMedicalDocument, deletePatientMedicalDocumentRecord } from '@uplift/api';
import { Formik } from 'formik';
import { Alert } from '../../../../../Alert';
import { CancelButton, SubmitButton } from '../../../../../Form';
import { TextInput } from '../../../../../Inputs';
import { useAlert } from '../../../../../AlertProvider';


export const DocumentDeleteModal: React.VFC<{
  open: boolean;
  onClose: () => void;
  onSuccess: () => Promise<void>;
  document?: PatientUploadedMedicalDocument;
}> = (props) => {
  const alert = useAlert();
  const { data: patient } = useUserQuery(props.document?.patientId);

  const documentDeleteValidationSchema = React.useMemo(() => Yup.object().shape({
    reasonForDelete: Yup.string().required('A deletion reason is required'),
  }), []);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        id: props.document?.id,
        reasonForDelete: '',
      }}
      validateOnMount
      validationSchema={documentDeleteValidationSchema}
      onSubmit={async (values) => {
        if (!props.document) {
          return;
        }

        try {
          await deletePatientMedicalDocumentRecord(props.document.patientId, props.document.id, values.reasonForDelete);
          await props.onSuccess();
          alert.success('Document deleted');
        } catch (err) {
          alert.error(<>There was a problem deleting the document. Try again or contact <strong>help@joinuplift.co</strong></>);
          throw err;
        }
      }}
    >
      <Modal
        open={props.open}
        onClose={props.onClose}
        fullWidth
        maxWidth="md"
        PaperProps={{ style: { maxWidth: '600px' } }}
        title="Delete document"
      >
        <ModalContent>
          <Alert severity="warning">
            <Typography>
              Deleting will remove this document from {patient?.firstName}’s chart and this action cannot be undone.
            </Typography>
          </Alert>

          <Box mt={3} width="100%">
            <TextInput
              name="reasonForDelete"
              label="Why are you deleting this document?"
              color="secondary"
              multiline
              minRows={1}
              fullWidth
            />
          </Box>
        </ModalContent>
        <ModalActions>
          <CancelButton onClick={props.onClose}>Cancel</CancelButton>
          <SubmitButton color="error">Delete document</SubmitButton>
        </ModalActions>
      </Modal>
    </Formik>
  );
};
